import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

// Calendar
const Calendar = () => import(/* webpackChunkName: "extra" */ '@/views/Calendar/Calendar.vue');
// Charts
const Charts = () => import(/* webpackChunkName: "dashboard" */ '@/views/Charts.vue');

// Components pages
const Buttons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Buttons.vue');
const Cards = () => import(/* webpackChunkName: "components" */ '@/views/Components/Cards.vue');
const GridSystem = () => import(/* webpackChunkName: "components" */ '@/views/Components/GridSystem.vue');
const Notifications = () => import(/* webpackChunkName: "components" */ '@/views/Components/Notifications.vue');
const Icons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Icons.vue');
const Typography = () => import(/* webpackChunkName: "components" */ '@/views/Components/Typography.vue');

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const AlternativeDashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/AlternativeDashboard.vue');
const Widgets = () => import(/* webpackChunkName: "dashboard" */ '@/views/Widgets.vue');

// Forms pages
const FormElements = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormElements.vue');
const FormComponents = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormComponents.vue');
const FormValidation = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormValidation.vue');

// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/GoogleMaps.vue');
const VectorMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/VectorMaps.vue');

// Pages
const User = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Pricing = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
const TimeLine = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
const Register = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
const Lock = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
const SortableTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');

// Envios paginas
const NuevoEnvio = () => import('@/views/Envíos/NuevoEnvio.vue');
const EnviosProgramados = () => import('@/views/Envíos/EnviosProgramados.vue');
const Plantillas = () => import('@/views/Envíos/Borradores.vue');
const SMSlink = () => import('@/views/Envíos/SMSlink.vue');
const SMSlinkIframe = () => import('@/views/Envíos/SMSlinkIframe.vue');

// Contactos paginas
const ListaContactos = () => import('@/views/Contactos/ListaContactos.vue');
const NuevaListaContactos = () => import('@/views/Contactos/NuevaLista.vue');
const Blacklist = () => import('@/views/Contactos/Blacklist.vue');
const NuevoBlacklist = () => import('@/views/Contactos/NuevoBlacklist.vue');

// Cuenta paginas
const Perfil = () => import('@/views/Cuenta/Perfil.vue');
const Usuarios = () => import('@/views/Cuenta/Usuarios.vue');
const NuevoUsuario = () => import('@/views/Cuenta/NuevoUsuario.vue');
const MisCompras = () => import('@/views/Cuenta/MisCompras.vue');
const ComprarCred = () => import('@/views/Cuenta/ComprarCred.vue');

// Reportes paginas
const ReporteMO = () => import('@/views/Reportes/ReporteMO.vue');
const ReporteMT = () => import('@/views/Reportes/ReporteMT.vue');
const ReporteLog = () => import('@/views/Reportes/ReporteLog.vue');

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  name: 'Components',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'cards',
      name: 'Cards',
      component: Cards
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }
  ]
};
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/elements',
  name: 'Forms',
  children: [
    {
      path: 'elements',
      name: 'Form elements',
      component:  FormElements
    },
    {
      path: 'components',
      name: 'Form components',
      component:  FormComponents
    },
    {
      path: 'validation',
      name: 'Form validation',
      component:  FormValidation
    }
  ]
};

let tablesMenu = {
  path: '/tables',
  component: DashboardLayout,
  redirect: '/table/regular',
  name: 'Tables menu',
  children: [
    {
      path: 'regular',
      name: 'Tables',
      component: RegularTables
    },
    {
      path: 'sortable',
      name: 'Sortable',
      component: SortableTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }
  ]
};

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  name: 'Maps',
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'vector',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
};

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  name: 'Pages',
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
};

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        noBodyBackground: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing
    },
    {
      path: '/lock',
      name: 'Lock',
      component: Lock
    },
    { path: '*', component: NotFound }
  ]
};

let enviosPages = {
  path: '/envios',
  component: DashboardLayout,
  name: 'Envios',
  children: [
    {
      path: '/envios/nuevo-envio',
      name: 'Nuevo Envio',
      component: NuevoEnvio
    },
    {
      path: '/envios/envios-programados',
      name: 'Envios Programados',
      component: EnviosProgramados
    },
    {
      path: '/envios/plantillas',
      name: 'Plantillas',
      component: Plantillas
    },
    {
      path: '/envios/sms-link',
      name: 'SMS Landing',
      component: SMSlink
    }
    ,
    {
      path: '/envios/sms-link/add',
      name: 'SMS Landing',
      component: SMSlinkIframe
    }
    ,
    {
      path: '/envios/sms-link/edit',
      name: 'SMS Landing',
      component: SMSlinkIframe
    }
]
}

let contactosPages = {
  path: '/contactos',
  component: DashboardLayout,
  name: 'Contactos',
  children: [
    {
      path: '/contactos/nueva-lista',
      name: 'Nueva Lista de Contactos',
      component: NuevaListaContactos
    },
    {
      path: '/contactos/lista-contactos',
      name: 'Lista Contactos',
      component: ListaContactos
    },
    {
      path: '/contactos/blacklist',
      name: 'Blacklist',
      component: Blacklist
    },
    {
      path: '/contactos/nuevo-blacklist',
      name: 'Nuevo Blacklist',
      component: NuevoBlacklist
    }
  ]
}

let cuentaPages = {
  path: '/cuenta',
  component: DashboardLayout,
  name: 'Cuenta',
  children: [
    {
      path: '/cuenta/perfil',
      name: 'Perfil',
      component: Perfil
    },
    {
      path: '/cuenta/nuevo-usuario',
      name: 'Nuevo Usuario',
      component: NuevoUsuario
    },
    {
      path: '/cuenta/usuarios',
      name: 'Usuarios',
      component: Usuarios
    },
    {
      path: '/cuenta/comprar-creditos',
      name: 'Comprar Créditos',
      component: ComprarCred
    },
    {
      path: '/cuenta/historial-compras',
      name: 'Historial de Compras',
      component: MisCompras
    }
  ]
}

let reportePages = {
  path: '/reportes',
  component: DashboardLayout,
  name: 'Reportes',
  children: [
    {
      path: '/reportes/reporte-mt',
      name: 'Reporte MT',
      component: ReporteMT
    },
    {
      path: '/reportes/reporte-mo',
      name: 'Reporte MO',
      component: ReporteMO
    },
    {
      path: '/reportes/reporte-log',
      name: 'Reporte LOG',
      component: ReporteLog
    }
  ]
}

const routes = [
  {
    path: '/',
    redirect: '/login',
    name: 'Home'
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  enviosPages,
  contactosPages,
  cuentaPages,
  reportePages,
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard layout',
    children: [
      {
        path: 'dashboard_orig',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'dashboard',
        name: 'Alternative',
        component: AlternativeDashboard,
        meta: {
          navbarType: 'light'
        }
      },
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets
      }
    ]
  },
  authPages,
];

export default routes;
